let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4315y")).then(() => parcelRequire('4GuUb'));